module.exports = __webpack_public_path__ + "static/media/ceragon.fw_.ba19c895.png";